import { render, staticRenderFns } from "./TaskCreatedActivity.vue?vue&type=template&id=4b94e8be"
import script from "./TaskCreatedActivity.vue?vue&type=script&lang=js"
export * from "./TaskCreatedActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports